import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { CarrierDto } from "./useGetCarriers";

export type CarrierUpsertDto = Omit<CarrierDto, 'id' | 'sites'> & { siteIds?: string[] };

const path = (businessId: string) => `/api/businesses/${businessId}/carriers`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, carrierId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${carrierId}`,
  method: HttpMethod.PUT,
});

const useUpsertCarrier = (carrierId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = carrierId
    ? updateSpec(business.id, carrierId)
    : createSpec(business.id);

  return useUserRequest<CarrierUpsertDto, string>(spec, options);
}

export default useUpsertCarrier;
